import { TbPhoto } from 'react-icons/tb';
import type { IconProps } from './IconBase';
import { IconBase } from './IconBase';

export const ImageIcon = (props: IconProps) => {
  return <IconBase icon={TbPhoto} {...props} />;
};
